import { BaseModel, BusinessOwnership, DATEPICKER, ToStartOfLocalDateString } from '@core/data-access';
import { Default } from '@core/util';
import { Exclude, Expose, Type } from 'class-transformer';
import { AddressModel } from '@core/address';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';

@Exclude()
export class CompanyModel extends BaseModel {
  @Expose() leadId!: number;
  @Expose() uen!: string;
  @Expose() companyName!: string;
}

@Exclude()
export class MyInfoBusinessModel extends BaseModel {
  @Expose() entityName!: string; // TODO: rename to companyName

  @Expose() uen!: string;

  @Expose() leadId!: number;

  @Expose() companyType!: string;

  @Expose() businessConstitution!: string;

  @Expose() businessType!: string;

  @Expose() businessStatus!: string;

  @Expose() countryId!: string | number;

  @Expose() businessOwnership!: BusinessOwnership;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  commencementDateOnly!: string;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  businessExpiryDateOnly!: string;

  @Expose() primaryActivityCode!: string;

  @Expose() secondaryActivityCode!: string;

  @Expose() address!: AddressModel;

  @Expose() fullAddress!: string;

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  historyNameAndUEN!: UploadFileControl;

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  appointments!: UploadFileControl;

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  shareholders!: UploadFileControl;

  @Expose() capitalType!: string;

  @Expose()
  @Type(() => Number)
  shareAllotedAmount!: number; // TODO: rename to sharedAllotedAmount

  @Expose()
  @Type(() => Number)
  issuedCapitalAmount!: number;

  @Expose()
  @Type(() => Number)
  paidupCapitalAmount!: number; // TODO: rename to currentPaidUpCapital

  @Expose() currency!: string;

  @Expose() natureOfBusiness!: string;

  @Expose() secondaryNatureOfBusiness!: string;

  get company() {
    const company = CompanyModel.createEmpty();
    company.companyName = this.entityName;
    company.uen = this.uen;
    company.leadId = this.leadId;

    return company;
  }
}
